import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Porto1 = () => {
  const projects = [
    { image: "/images/porto1/porto1-0.jpg" },
    { image: "/images/porto1/porto1-1.jpg" },
    { image: "/images/porto1/porto1-2.jpg" },
    { image: "/images/porto1/porto1-3.jpg" },
    { image: "/images/porto1/porto1-4.jpg" },
    { image: "/images/porto1/porto1-5.jpg" },
    { image: "/images/porto1/porto1-6.jpg" },
    { image: "/images/porto1/porto1-7.jpg" },
    { image: "/images/porto1/porto1-8.jpg" },
    { image: "/images/porto1/porto1-9.jpg" },
    { image: "/images/porto1/porto1-10.jpg" },
    { image: "/images/porto1/porto1-11.jpg" },
    { image: "/images/porto1/porto1-12.jpg" },
    { image: "/images/porto1/porto1-13.jpg" },
    { image: "/images/porto1/porto1-15.jpg" },
    { image: "/images/porto1/porto1-16.jpg" },
  ];

  return (
    <div className="py-10">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="rounded-2xl"
      >
        {projects.map((project, index) => (
          <SwiperSlide key={index}>
            <div className="overflow-hidden rounded-2xl shadow-lg group relative transition-transform duration-500 hover:scale-105 hover:shadow-2xl">
              <img
                src={project.image}
                loading="lazy"
                alt="Portfolio"
                className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
              />
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
                {/* يمكن إضافة أي أيقونات أو نص هنا */}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Porto1;
